// extracted by mini-css-extract-plugin
export default {"cardWrapper":"SectionErrorBoundary_cardWrapper__WTPgh","background":"SectionErrorBoundary_background__891eT"};